import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { medicinaModulo } from '../../diccionarios/medicinaModulo';

@Injectable({
  providedIn: 'root'
})
export class GaritaService {
  url: any;
  urlBase: any;
  diccionario: any;
  constructor(private http: HttpClient,
              private util: UtilsService) {
              this.url = this.util.getNomina()+"marcacion-fabmedical/";
              this.urlBase = this.util.getNomina()+"marcacion-fabmedical/";
              //this.url = "http://localhost:8080/nomina-api/v1/api/services/marcacion-fabmedical/";
              //this.urlBase = "http://localhost:8080/nomina-api/v1/api/services/marcacion-fabmedical/";

              this.diccionario = medicinaModulo;
  }

  getTarjeta(innnTarjeta, puerta?:string, horario?:string, tipo = 0) {
    const headers = this.util.getHeaders();
    if(tipo === 0)
      return this.http.get<any>(this.url + this.diccionario.url.garita + innnTarjeta);
    else
      return this.http.get<any>(this.url + this.diccionario.url.garita + innnTarjeta+'/'+puerta+'/'+horario);
      // .pipe(
      //   map(res => res[this.util.innEstructuraRespuesta])
      // );
  }//
  
  getCedula(cedula: string, puerta?:string, horario?:string, tipo = 0) {
    const headers = this.util.getHeaders();
    if(tipo === 0)
      return this.http.get<any>(this.url + this.diccionario.url.confirmacion + cedula);
    else
      return this.http.get<any>(this.url + this.diccionario.url.confirmacion + cedula+'/'+puerta+'/'+horario);
  }

  getListaAreas(){
    const headers = this.util.getHeaders();
    return this.http.get<any>(this.urlBase + this.diccionario.url.listas);
  }

  getListaPuerta(idArea:String){
    const headers = this.util.getHeaders();
    return this.http.get<any>(this.urlBase + this.diccionario.url.listas+'/puertas/'+idArea);
  }

  postCedula(cedula) {
    const headers = this.util.getHeaders();
    return this.http.post<any>(this.url + this.diccionario.url.confirmacion,cedula);
  }

}//
